import { gql } from 'graphql-request'
import { clearCookies, clearSellerData } from '@/resources/utils'
import { client } from '@/proxy/client'
import { clearDatadogUser } from '@/monitoring/datadog'

const LOGOUT_MUTATION = gql`
  mutation sellerLogout {
    logout
  }
`

const removeSprinklrWidget = () => {
  if (window.sprChat) {
    window.sprChat('disable')
    window.sprChat('clearSession')
  }
}

export const doLogout = async (redirect = true) => {
  try {
    await client.request(LOGOUT_MUTATION)
  } catch (ex) {
    console.warn(ex)
  } finally {
    removeSprinklrWidget()
    clearCookies()
    clearSellerData()
    clearDatadogUser()
    if (redirect) window.location.href = '/login'
  }
}
